import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import {CSVLink} from "react-csv";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class tvsAsset extends Component{
    constructor(props){
        super(props);
        this.state = {
            asset_response: [],
            loading: true,
            ExcelHeaders : [
                { label: "S.No.", key: "SNo" },
                { label: "Asset Serial", key: "AssetSerial" },
                { label: "ISKU", key: "ISKU" },
                { label: "Asset Condition", key: "AssetCondition" },
                { label: "Current Status", key: "CurrentStatus" }
            ],
            ExcelData : []
        }
    }
    componentDidMount(){
        this.refreshAssets();
    }
    refreshAssets(){
        const token = localStorage.usertoken;
        let warehouse_id = '';
        if(token != null) {
            const decoded = jwt_decode(token);
            warehouse_id = decoded.warehouse_id
        }
        if($.fn.DataTable.isDataTable("#assetsTable")){
            $('#assetsTable').DataTable().destroy();
        }
        axios.get(config.get('API_URL')+'/inventory/assets?user_id='+warehouse_id,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`,
                SalesforceToken: ` ${localStorage.salesforce_token}`
            }
        }).then(response => {

            var tempExcelData=[];
            response.data.map((value, index)=>{
                var tempData={
                    SNo:index+1,
                    AssetSerial:value.Name,
                    ISKU:value.SKU__r.Name,
                    AssetCondition:value.Asset_Condition__c,
                    CurrentStatus:value.Current_Status__c
                }
                tempExcelData.push(tempData);
            });

            this.setState({
                asset_response: response.data,
                ExcelData:tempExcelData
            });
            $('#assetsTable').DataTable({
                "oLanguage":{
                    "sEmptyTable": "There are no assets available"
                }
            });
            this.setState({
                loading: false
            })
        });
    }
    render(){
        let assets_data = this.state.asset_response.map((value, index) => {
            return (
                <tr key={index + 1}>
                    <td>{index + 1}</td>
                    <td>{value.Name}</td>
                    <td>{value.SKU__r.Name}</td>
                    <td>{value.Asset_Condition__c}</td>
                    <td>{value.Current_Status__c}</td>
                    <td>{value.Facility_Name__r.Name}</td>
                </tr>
            )
        });
        return(
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div>
                                <div className="col-mid-12 no-padd">
                                    <div className="card title-card-bottom-space">
                                        <div className="header">
                                            <h4 className="title">Assets</h4>
                                            <p className="category"></p>
                                        </div>
                                    </div>
                                </div>
                                <div className="clearfix"></div>
                                <div className="content bgcolor">
                                    <div className="row">
                                        <div className='sweet-loading'>
                                            <BeatLoader
                                                css={override}
                                                sizeUnit={"px"}
                                                size={20}
                                                color={'#123abc'}
                                                loading={this.state.loading}
                                            />
                                        </div>
                                        <div className="col-lg-12 ">
                                            <div className="p-5">
                                                <div className="col-md-12">
                                                    <div className="col-md-3">
                                                    </div>
                                                    <div className="col-md-2 rightText p-0">
                                                        {/*<label>Facility Name</label>*/}
                                                    </div>
                                                    <div className="col-md-2">
                                                        {/*<select id="facilityName" name="facilityName" >*/}
                                                        {/*    <option value="Select...">Select...</option>*/}
                                                        {/*</select>*/}
                                                    </div>
                                                    <div className="col-md-5">
                                                        <CSVLink data={this.state.ExcelData} headers={this.state.ExcelHeaders} >
                                                            <span className="btn btn-primary pull-right "> Export To Excel</span>
                                                        </CSVLink>
                                                    </div>
                                                </div>


                                                <br />
                                            </div>

                                            <table className="table table-striped table-hover" id="assetsTable">
                                                <thead>
                                                <tr>
                                                    <th>S.No.</th>
                                                    <th>Asset serial number</th>
                                                    <th>ISKU</th>
                                                    <th>Asset condition</th>
                                                    <th>Current status</th>
                                                    <th>Facility Name</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {assets_data}
                                                </tbody>
                                            </table>
                                        </div>





                                    </div>
                                </div>


                                <div className="clearfix"></div>

                                <div className="footer">
                                    <div className="stats"><i></i></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default tvsAsset;
